import React from "react";

import face from "../files/face.jpg";

export default () => (
  <img style={{ maxWidth: 300, marginLeft: 10 }} src={face} />
);
